<template>
  <div>

    <pageTable ref="table"
               :tableTitle="tableColumn"
               :searchData="searchData"
               :defaultPageSize="20"
               :pageSizeOptions="[20,50,100]"
               tableApi="admin/agent/lists"
    >
      <template v-slot:searchFormItem>
        <FormItem prop="name">
          <Input type="text" v-model="searchData.name" placeholder="手机号或名称" class="lx-search-item"></Input>
        </FormItem>
      </template>

      <template v-slot:otherBtn>
        <FormItem>
          <Button type="primary" @click="showEditDrawer(0)">添加</Button>
        </FormItem>
      </template>

    </pageTable>

    <edit-form v-if="showEdit"
               :show-edit="showEdit"
               :id="editId"
               ref="editModel"
               @cancel-edit="closeEditDrawer"
               @edit-success="editSuccess"
    >
    </edit-form>


    <Modal
            v-model="showAddAgentUser"
            title="添加推广站点"
            :loading="loading"
            @on-ok="doAddUser">
      <input type="text" v-model="stationUserMobile" placeholder="请输入站点用户手机号">
    </Modal>

    <!-- <Modal
            v-model="editAgentStationInfo.isShow"
            :title="editAgentStationInfo.agent_info.name"
            :loading="editAgentStationInfo.loading"
            fullscreen
            @on-ok="doEditAgentStationInfo">
      <div>

          <Checkbox
                  :indeterminate="editAgentStationInfo.indeterminate"
                  :value="editAgentStationInfo.checkAll"
                  @click.prevent.native="checkAllAgentStation">全选</Checkbox>
          <Divider size="small" class="ivu-m-0" />
          <CheckboxGroup v-model="editAgentStationInfo.checked" @on-change="editAgentStationInfoChange" class="custom-checkbox">
            <Checkbox v-for="(item,key) in editAgentStationInfo.allStations" :label="item.station_id">{{item.gas_name}}</Checkbox>
          </CheckboxGroup>
      </div>
    </Modal> -->

    <Drawer :title="editAgentStationInfo.name"
            :mask-closable="true"
            width="1000"
            v-model="editAgentStationInfo.isShow"
    >
      <editStation :id="editAgentStationInfo.id" v-if="editAgentStationInfo.isShow"></editStation>
    </Drawer>

    <Drawer :title="editAgentCompanyInfo.name + ' 车队管理'"
            :mask-closable="true"
            width="800"
            v-model="editAgentCompanyInfo.isShow"
    >
      <editCompany
        :id="editAgentCompanyInfo.id"
        v-if="editAgentCompanyInfo.isShow"
        @edit-success="editAgentCompanySuccess"
      ></editCompany>
    </Drawer>


  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";
  import editStation from "./editStation";
  import editCompany from "./editCompany";
  import editForm from "./edit";
  export default {
    name: "lists",
    components:{pageTable,editForm,editStation,editCompany},
    data() {
      return {
        showEdit:false,
        editId:0,
        searchData: {
          name:'',
        },
        commissionSearchData:{
          agent_user_id:0
        },
        shareSearchData:{
          agent_user_id:0
        },
        stationSearchData:{
          agent_user_id:0
        },
        showAddAgentUser:false,
        addUserAgentID:0,
        stationUserMobile:'',
        loading:false,
        tableColumn: [
          {title: '编号',key: 'id',width: 80},
          {title: '姓名',key: 'name',maxWidth:320},
          {title: '手机号',key: 'mobile',width:140},
          // {title: '可加油站点',key: 'mobile',render:(h,params)=>{
          //   let content = [];
          //   content.push(h('Tag',{props:{color:'blue'},style:{width:'80px',textAlign:'center'}},params.row.station_num));
          //   content.push(h('Button',{
          //     props: {type: 'primary', size: 'small',},
          //     style: {marginLeft: '5px'},
          //     on: {click: () => {this.showEditAgentStation(params.row)}
          //     }
          //   },'编辑'));
          //     return h('div',content)

          //   }},
          {title: '车队', key: 'mobile', width: 340, render:(h,params)=>{
              let content = [];
              content.push(h('Tag',{props:{color:'blue'},style:{width:'60px',textAlign:'center'}},params.row.company_num));
              content.push(h('Button',{
                props: {type: 'primary', size: 'small',},
                style: {marginLeft: '5px'},
                on: {click: () => {this.showEditAgentCompany(params.row)}
                }
              },'编辑'));
              return h('div',content)
            }},
          {title: '操作',align:'center',width:140,render:(h,params)=>{
              let content=[];
             /* content.push(h('Button',{
                  props: {type: 'primary', size: 'small',},
                  style: {marginLeft: '5px'},
                  on: {click: () => {this.showSpreadStation(params.row.id)}
                }
              },'推广站点'));*/
              content.push(h('Button',{
                props: {type: 'error', size: 'small',},
                style: {marginLeft: '5px'},
                on: {click: () => {this.del(params.row.id)}
                }
              },'删除'))
              content.push(h('Button',{
                props: {type: 'primary', size: 'small',},
                style: {marginLeft: '5px'},
                on: {click: () => {this.showEditDrawer(params.row.id)}
                }
              },'编辑'))
              return h('div',content)
            }},
        ],
        commissionTableColumn:[
          {title: '站点名称',key: 'gas_name'},
          {title: '站点类型',key: 'station_type_name'},
          {title: '拨打电话',key: 'mobile'},
          {title: '拨打时间',key: 'create_time'},
          {title: '合伙人佣金',key: 'agent_commission'},
        ],
        shareTableColumn:[
          {title: '注册用户',key: 'mobile'},
          {title: '昵称',key: 'nick_name'},
          {title: '注册时间',key: 'create_time'},
          {title: '佣金',key: 'amount'},
        ],
        editAgentStationInfo:{
          isShow:false,
          checkAll:false,
          indeterminate: true,
          name:'',
          id:0,
          agent_info:{name:''},
          checked:[],
          allStations:[],
          allStationID:[],
          loading:false,
        },
        editAgentCompanyInfo:{
          isShow:false,
          name:'',
          id:0,
          agent_info:{},
        }
      }
    },
    methods: {
      showEditDrawer(id){
        this.showEdit = true;
        this.editId = id
      },
      closeEditDrawer(){
        this.showEdit = false
        this.editId = 0
      },
      editSuccess(){
        this.$refs.table.getLists();
        this.showEdit = false
      },
      async del(id){
        if (!id) return this.$commonFun.errorTip('参数错误')
        this.$Modal.confirm({
          title: '提示',
          content: '<p>确认删除？</p>',
          onOk: async () => {
            let res = await this.$commonFun.postProxy('admin/agent/del',{id:id})
            if(res.code === 200){
              this.$Message.success('操作成功')
              this.$refs.table.getLists();
            }else{
              this.$Message.error(res.msg || '操作失败')
            }
          },
          onCancel: () => {
            //console.log('点击了取消')
          }
        })
      },
      showStationTable(agent_user_id){
        this.stationSearchData.agent_user_id = agent_user_id
      },
      showCommissionTable(agent_user_id){
        this.commissionSearchData.agent_user_id = agent_user_id
      },
      async setPromoteFee(row){
        let res = await this.$commonFun.postProxy('admin/agent/setPromoteFee',{agent_id:row.id,promote_fee:row.agent_promote_fee})
        this.$commonFun.dealApiResult(res)
        this.$set(row,'$isEdit',false)
      },
      async setShareCommission(row){
        let res = await this.$commonFun.postProxy('admin/agent/setShareCommission',{agent_id:row.id,agent_share_commission:row.agent_share_commission})
        this.$commonFun.dealApiResult(res)
        this.$set(row,'$isEditShare',false)
      },
      addUserAgent(agent_user_id){
        if (agent_user_id>0){
          this.showAddAgentUser = true;
          this.addUserAgentID = agent_user_id
        }else{
          this.$commonFun.errorTip('该合伙人尚未注册')
        }
      },
      async doAddUser(){
        this.loading=true
        let res = await this.$commonFun.postProxy('admin/agent/addUserAgent',{agent_user_id:this.addUserAgentID,station_user_mobile:this.stationUserMobile})
        this.loading=false
        this.$commonFun.dealApiResult(res,()=>{
          this.showAddAgentUser = false;
          this.addUserAgentID = 0
          this.stationUserMobile=''
          this.$commonFun.successTip(res.msg)
        })
      },
      async showEditAgentStation(data){
        this.editAgentStationInfo.isShow = true
        this.editAgentStationInfo.name = data.name
        this.editAgentStationInfo.id = data.id
      },
      checkAllAgentStation(){
        this.editAgentStationInfo.checkAll = this.editAgentStationInfo.checked.length !== this.editAgentStationInfo.allStationID.length
        this.editAgentStationInfo.indeterminate = false;
        console.log(this.editAgentStationInfo.checkAll)
        if (this.editAgentStationInfo.checkAll) {
          this.editAgentStationInfo.checked = this.editAgentStationInfo.allStationID;
        } else {
          this.editAgentStationInfo.checked = [];
        }
      },
      editAgentStationInfoChange (data) {
        console.log(data)
        if (data.length === this.editAgentStationInfo.allStations.length) {
          this.editAgentStationInfo.indeterminate = false;
          this.editAgentStationInfo.checkAll = true;
        } else if (data.length > 0) {
          this.editAgentStationInfo.indeterminate = true;
          this.editAgentStationInfo.checkAll = false;
        } else {
          this.editAgentStationInfo.indeterminate = false;
          this.editAgentStationInfo.checkAll = false;
        }
      },
      async doEditAgentStationInfo(){
        let agent_id =  this.editAgentStationInfo.agent_info.id;
        if (!agent_id) return this.$commonFun.errorTip('请选择需要编辑的代理')
        this.editAgentStationInfo.loading=true
        let res = await this.$commonFun.postProxy('admin/agent/editAgentStation',{id:agent_id,checked: this.editAgentStationInfo.checked})
        this.$commonFun.dealApiResult(res,()=>{
          this.$commonFun.successTip(res.msg,()=>{
            this.editAgentStationInfo.isShow = false
            this.editAgentStationInfo.indeterminate = false;
            this.editAgentStationInfo.checkAll = false;
            this.editAgentStationInfo.loading=false
            this.editAgentStationInfo.checked = [];
            this.editAgentStationInfo.agent_info = {}
            this.$refs.table.changePage(1);
          })

        })
      },

      showEditAgentCompany(data){
        this.editAgentCompanyInfo.isShow = true
        this.editAgentCompanyInfo.name = data.name || ''
        this.editAgentCompanyInfo.id = data.id || 0
        this.editAgentCompanyInfo.agent_info = data
      },
      editAgentCompanySuccess(){
        this.editAgentCompanyInfo.isShow = false
        this.editAgentCompanyInfo.name = ''
        this.editAgentCompanyInfo.id = 0
        this.editAgentCompanyInfo.agent_info = {}
        this.$refs.table.changePage(1)
      }
    },
    mounted() {
    },
  }
</script>

<style scoped>
 .custom-checkbox .ivu-checkbox-inner {
   width: 100px; /* 设置你想要的宽度 */
 }
</style>
